export const setChatOpened = 'chat/setChatOpened'
export const setChatUser = 'chat/setUser'



// WEBPACK FOOTER //
// ./src/domain/chat/store/mutations-types.js